import React from "react";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import ERROR_PAGE from "./components/page/ErrorPage.component";
import { useOktaAuth, LoginCallback, SecureRoute } from "@okta/okta-react";
import GRID_LAYOUT_VIEW from "./views/projects/Projects.view";
import DETAILS_VIEW from "./views/projects/Details.view";
import ScrollToTop from "./shared/hooks/ScrollToTop";
import { ErrorConstants } from "./shared/constants/errors.constants";
import { Errors } from "./shared/enums/errors.enums";

function removeHashFromUri(str: string): string {
  if (str.startsWith("/#/")) {
    return str.substring(2);
  } else {
    return str;
  }
}

function App(): React.ReactElement {
  const h = useHistory();
  const { oktaAuth, authState } = useOktaAuth();
  const isAuthenticated: boolean = authState?.isAuthenticated ?? false;

  return (
    <ScrollToTop>
      {!isAuthenticated && oktaAuth.isLoginRedirect() ? (
        <>
          <Route component={LoginCallback} />
          {h.location.pathname !==
          removeHashFromUri(oktaAuth.getOriginalUri() ?? "/") ? (
            <Redirect
              to={removeHashFromUri(oktaAuth.getOriginalUri() ?? "/")}
            />
          ) : null}
        </>
      ) : null}
      <Switch>
        <SecureRoute exact path="/" component={GRID_LAYOUT_VIEW} />
        <SecureRoute
          path="/project-details/:projectId"
          component={DETAILS_VIEW}
        />
        <SecureRoute
          exact
          path="/NotFound"
          render={() => <ERROR_PAGE error={ErrorConstants[Errors.NOT_FOUND]} />}
        />
        <SecureRoute
          exact
          path="/ServerError"
          render={() => (
            <ERROR_PAGE error={ErrorConstants[Errors.SERVER_ERROR]} />
          )}
        />
        <Redirect to="/NotFound" />
      </Switch>
    </ScrollToTop>
  );
}

export default App;
